function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1904(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 33.16,
    height: 12.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.55125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.58,
    y: 6.205
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12.41,
    width: 33.16,
    height: 34.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.526666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.58,
    y: 29.66
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 46.91,
    width: 33.16,
    height: 40.01,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.58,
    y: 66.91499999999999
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.92,
    width: 33.16,
    height: 48.61,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.632
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.58,
    y: 111.225
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 135.53,
    width: 33.16,
    height: 66.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.632
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.58,
    y: 168.695
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 201.85,
    width: 33.16,
    height: 66.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.526666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.58,
    y: 235.14999999999998
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 268.46,
    width: 33.16,
    height: 69.52,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.632
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.58,
    y: 303.21999999999997
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 337.98,
    width: 33.16,
    height: 70.59,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.632
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.58,
    y: 373.27500000000003
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 408.57,
    width: 33.16,
    height: 72.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.737142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.58,
    y: 444.8
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 481.02,
    width: 33.16,
    height: 72.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.737142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.58,
    y: 517.365
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 553.71,
    width: 33.16,
    height: 72.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.684444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.58,
    y: 590.065
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 626.42,
    width: 33.16,
    height: 73.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.526666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.58,
    y: 663.2099999999999
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.16,
    y: 0,
    width: 43.84,
    height: 56.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.08,
    y: 28.34
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.01,
    y: 0,
    width: 44.14,
    height: 56.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 99.08000000000001,
    y: 28.34
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.15,
    y: 0,
    width: 44.42,
    height: 56.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.345714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.36,
    y: 28.34
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.57,
    y: 0,
    width: 46.37,
    height: 56.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.728333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.755,
    y: 28.34
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.94,
    y: 0,
    width: 46.81,
    height: 56.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.85125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.345,
    y: 28.34
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.75,
    y: 0,
    width: 48.69,
    height: 56.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.9557142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.095,
    y: 28.34
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.44,
    y: 0,
    width: 51.26,
    height: 56.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1259999999999994
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 333.07,
    y: 28.34
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.7,
    y: 0,
    width: 51.48,
    height: 56.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 384.44,
    y: 28.34
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.18,
    y: 0,
    width: 53.06,
    height: 56.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.71000000000004,
    y: 28.34
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.24,
    y: 0,
    width: 57.27,
    height: 56.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.085
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 491.875,
    y: 28.34
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 520.51,
    y: 0,
    width: 57.35,
    height: 56.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.097142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 549.185,
    y: 28.34
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577.86,
    y: 0,
    width: 60.85,
    height: 56.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.085
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 608.285,
    y: 28.34
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 638.71,
    y: 0,
    width: 61.29,
    height: 56.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.085
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.355,
    y: 28.34
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.16,
    y: 56.68,
    width: 62.11,
    height: 56.01,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.334999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.215,
    y: 84.685
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.16,
    y: 112.69,
    width: 62.11,
    height: 60.36,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.036
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.215,
    y: 142.87
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.16,
    y: 173.05,
    width: 62.11,
    height: 60.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.215,
    y: 203.33
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.16,
    y: 233.62,
    width: 62.11,
    height: 61.82,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.215,
    y: 264.53000000000003
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.16,
    y: 295.44,
    width: 62.11,
    height: 63.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.211
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.215,
    y: 327.18
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.16,
    y: 358.92,
    width: 62.11,
    height: 66.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.872857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.215,
    y: 392.3
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.16,
    y: 425.68,
    width: 62.11,
    height: 66.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.215,
    y: 459.145
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.16,
    y: 492.61,
    width: 62.11,
    height: 67.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.872857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.215,
    y: 526.2950000000001
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.16,
    y: 559.98,
    width: 62.11,
    height: 68.47,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.215,
    y: 594.215
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.16,
    y: 628.45,
    width: 62.11,
    height: 71.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.76375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.215,
    y: 664.225
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.27,
    y: 56.68,
    width: 65.95,
    height: 67.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.24375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.245,
    y: 90.425
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.22,
    y: 56.68,
    width: 71.58,
    height: 67.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.135454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.01,
    y: 90.425
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.8,
    y: 56.68,
    width: 73.42,
    height: 67.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.43625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.51,
    y: 90.425
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.22,
    y: 56.68,
    width: 74.26,
    height: 67.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.135454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.35,
    y: 90.425
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.48,
    y: 56.68,
    width: 76.56,
    height: 67.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.248333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 418.76,
    y: 90.425
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.04,
    y: 56.68,
    width: 78.12,
    height: 67.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.641428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.1,
    y: 90.425
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 535.16,
    y: 56.68,
    width: 81.97,
    height: 67.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.248333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.145,
    y: 90.425
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 617.13,
    y: 56.68,
    width: 82.87,
    height: 67.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.248333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.565,
    y: 90.425
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.27,
    y: 124.17,
    width: 77.29,
    height: 75.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.744285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.915,
    y: 161.775
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.27,
    y: 199.38,
    width: 77.29,
    height: 78.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.587777777777779
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.915,
    y: 238.435
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.27,
    y: 277.49,
    width: 77.29,
    height: 80.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.66125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.915,
    y: 317.775
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.27,
    y: 358.06,
    width: 77.29,
    height: 83.45,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.041428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.915,
    y: 399.785
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.27,
    y: 441.51,
    width: 77.29,
    height: 83.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.881666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.915,
    y: 483.46999999999997
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.27,
    y: 525.43,
    width: 77.29,
    height: 85.15,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.440833333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.915,
    y: 568.005
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.27,
    y: 610.58,
    width: 77.29,
    height: 89.42,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.729000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.915,
    y: 655.2900000000001
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.56,
    y: 124.17,
    width: 78.45,
    height: 96.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.075000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.785,
    y: 172.49
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 124.17,
    width: 97.61,
    height: 96.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.805,
    y: 172.49
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.61,
    y: 124.17,
    width: 106.82,
    height: 96.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.106666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.02,
    y: 172.49
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.43,
    y: 124.17,
    width: 108.55,
    height: 96.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.106666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 509.705,
    y: 172.49
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.98,
    y: 124.17,
    width: 136.02,
    height: 96.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 631.99,
    y: 172.49
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.56,
    y: 220.81,
    width: 145.34,
    height: 92.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.465000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.23000000000002,
    y: 267.205
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.56,
    y: 313.6,
    width: 145.34,
    height: 93.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.518181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.23000000000002,
    y: 360.45000000000005
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.56,
    y: 407.3,
    width: 145.34,
    height: 106.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.766666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.23000000000002,
    y: 460.6
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.56,
    y: 513.9,
    width: 145.34,
    height: 186.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 36.335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.23000000000002,
    y: 606.9499999999999
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.89,
    y: 220.81,
    width: 382.11,
    height: 186.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 37.376
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 508.945,
    y: 314.25
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.89,
    y: 407.69,
    width: 382.11,
    height: 292.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 36.53875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 508.945,
    y: 553.845
  }, "\n        New_York\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1904);
export default __webpack_public_path__ + "static/media/1904.8f6344e1d84c1e233a3cd38ee00da02a.svg";
export { ForwardRef as ReactComponent };